import React from 'react';
import styled from 'styled-components';

interface AdminBlockWithSortVisibleProps {
  width: string;
  isColumn?: boolean;
  value: string;
  isASC: boolean;
  isSortField: boolean;
  handleDirectionChange: () => void;
}

const AdminBlockWithSortVisible: React.FC<AdminBlockWithSortVisibleProps> = ({
  width,
  isColumn,
  value,
  isASC,
  isSortField,
  handleDirectionChange,
}) => {
  return (
    <Block
      $width={width}
      $isColumn={isColumn}
      onClick={handleDirectionChange}
    >
      <ValueContainer>
        <Value>{value}</Value>
        <SelectDirection
          $isASC={isASC}
          $isSortField={isSortField}
        >
          ▼
        </SelectDirection>
      </ValueContainer>
    </Block>
  );
};

const Block = styled.div<{ $width: string; $isColumn: boolean | undefined }>`
  flex: ${({ $width }) => $width};

  display: flex;
  justify-content: center;
  align-items: center;

  min-width: 0;

  cursor: pointer;
  user-select: none;
  border-bottom: ${({ $isColumn, theme }) =>
    $isColumn ? 'none' : `0.5px solid ${theme.colors.color_Gray_04}`};
`;

const ValueContainer = styled.div`
  width: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Value = styled.span`
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  padding-left: 10px;

  text-align: center;
`;

const SelectDirection = styled.span<{ $isSortField: boolean; $isASC: boolean }>`
  margin-left: 4px;
  ${({ theme }) => theme.typography.Footer_02};
  color: ${({ theme, $isSortField }) =>
    $isSortField ? theme.colors.color_Gray_03 : theme.colors.color_Gray_05};
  transform: ${({ $isASC, $isSortField }) => {
    if (!$isSortField) return 'scale(0.7)';
    return $isASC ? 'scale(0.7)' : 'scaleY(-1) scale(0.7)';
  }};
  transition: transform 0.6s ease-in-out;
`;

export default AdminBlockWithSortVisible;
